export default function progressConfetti () {
  const meter = document.querySelector('.Progress');

  if (!meter) {
    return
  }

  const percentageDone = meter.dataset.currentStep / meter.dataset.totalSteps;
  const canvas = document.querySelector('canvas')

  if (!canvas) {
    return
  }

  const ctx = canvas.getContext('2d')
  canvas.width = 150
  canvas.height = 150
  const cx = ctx.canvas.width / 2
  const cy = ctx.canvas.height / 2
  let shouldConfettiRender = false

  let confetti = []
  const confettiCount = 75
  const gravity = 0.5
  const terminalVelocity = 3
  const drag = 0.075
  const colors = [
    {front: '#00b3e7', back: '#90DEF4'}
  ]

  const randomRange = (min, max) => Math.random() * (max - min) + min

  const initConfetti = () => {
    for (let i = 0; i < confettiCount; i++) {
      confetti.push({
        color: colors[Math.floor(0, colors.length)],
        dimensions: {
          x: randomRange(5, 10),
          y: randomRange(2, 15),
        },
        position: {
          x: randomRange(0, canvas.width),
          y: canvas.height - 1,
        },
        rotation: randomRange(0, 2 * Math.PI),
        scale: {
          x: 1,
          y: 1,
        },
        velocity: {
          x: randomRange(-25, 25),
          y: randomRange(0, -50),
        },
      })
    }
  }

  const render = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    confetti.forEach((confetto, index) => {
      let width = (confetto.dimensions.x * confetto.scale.x)
      let height = (confetto.dimensions.y * confetto.scale.y)

      // Move canvas to position and rotate
      ctx.translate(confetto.position.x, confetto.position.y)
      ctx.rotate(confetto.rotation)

      // Apply forces to velocity
      confetto.velocity.x -= confetto.velocity.x * drag
      confetto.velocity.y = Math.min(confetto.velocity.y + gravity, terminalVelocity)
      confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random()

      // Set position
      confetto.position.x += confetto.velocity.x
      confetto.position.y += confetto.velocity.y

      // Delete confetti when out of frame
      if (confetto.position.y >= canvas.height) confetti.splice(index, 1)

      // Loop confetto x position
      if (confetto.position.x > canvas.width) confetto.position.x = 0
      if (confetto.position.x < 0) confetto.position.x = canvas.width

      // Spin confetto by scaling y
      confetto.scale.y = Math.cos(confetto.position.y * 0.1)
      ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back

      // Draw confetto
      ctx.fillRect(-width / 2, -height / 2, width, height)

      // Reset transform matrix
      ctx.setTransform(1, 0, 0, 1, 0, 0)
    })

    if (shouldConfettiRender) {
      window.requestAnimationFrame(render)
    }
  }


  if (percentageDone == 1) {
    shouldConfettiRender = true
    setTimeout(() => {initConfetti()}, 3000)
    setTimeout(() => {
      shouldConfettiRender = false
    }, 20000)
  }

  render()
}
